import {useEffect, useRef} from 'react';

export default function DraggablePosition({onChange, capitalSize}) {

  const capital = useRef(null);

  useEffect(() => {
    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      let hasChange = false;
      const top = capital.current.offsetTop - pos2;
      if (top >= 0 && top <= 149) {
        capital.current.style.top = top + 'px';
        hasChange = true;
      }
      const left = capital.current.offsetLeft - pos1;
      if (left >= 0 && left <= 124) {
        capital.current.style.left = left + 'px';
        hasChange = true;
      }
      if (hasChange) {
        onChange({top: capital.current.style.top, left: capital.current.style.left});
      }
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    capital.current.onmousedown = dragMouseDown;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="draggable-frontier">
      <div ref={capital} className="draggable-capital" style={{width: capitalSize, height: capitalSize * 1.5, left: 196 / 2 - (capitalSize / 2)}}>

      </div>
    </div>
  );
}
